import type { DemoId } from "app/pages/sales-intelligence/types/demo-mode";
import type { RequestAdminFeature } from "app/pages/sales-intelligence/types/requestAdminFeature";

/** Identifies the industry-taxonomy demo among all demos. Consumers key their behavior on this specific id. */
export const INDUSTRY_TAXONOMY_DEMO_ID = "industry-taxonomy" as DemoId;

/** i18n copy namespace for this demo — `si.demo_mode.industry.*`. Separate from the id, which keys behavior. */
export const INDUSTRY_TAXONOMY_DEMO_COPY_NAMESPACE = "industry";

/** Feature key the demo banner's CTA asks the admin for access to. Names the capability, not the demo. */
export const INDUSTRY_TAXONOMY_ACCESS_REQUEST_FEATURE = "industryTaxonomy" satisfies RequestAdminFeature;

export const INDUSTRY_TAXONOMY_KB_ARTICLE_LINK =
    "https://support.similarweb.com/hc/en-us/articles/38066805004317-Using-Industry-Plus-in-Lead-Generation";
